import { ASSET_NETWORK } from "../../typings/assets";

export const EXPLORERS = {
  [ASSET_NETWORK.BSC]: "https://bscscan.com",
  [ASSET_NETWORK.ETH]: "https://etherscan.com",
};
